import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import styles from './style.module.css';
import SubmitButton from '../submit-button';
import { updatePagination, updatePaginationSkip, updatePaginationPreviousRoute } from '../../../../reducers/calculator';

class Pagination extends Component {
    componentDidMount(){
        const {
            props: {
                location: {
                    pathname
                },
                paginationState,
                updatePagination
            }
        } = this;

        if (pathname === '/') return null;

        const pagination = this.generatePagination();

        if(paginationState !== pagination.active){
            updatePagination(pagination.active);
        }
    }

    componentDidUpdate(){
        const {
            props: {
                location: {
                    pathname
                },
                paginationState,
                updatePagination
            }
        } = this;

        if (pathname === '/') return null;

        const pagination = this.generatePagination();

        if(paginationState !== pagination.active){
            updatePagination(pagination.active);
        }
    }

    getCurrentRoute(){
        const {
            props: {
                location,
                routes = []
            }
        } = this;

        const currentRoute = routes.find(({ path }) => location.pathname.endsWith(path));

        if (typeof currentRoute === 'undefined') {
            return routes[0];
        }

        return currentRoute;
    }

    generatePagination(){
        const {
            props: {
                location,
                routes = [],
                paginationSkipState,
                paginationPreviousRoute
            }
        } = this;

        const basePath = `/${location.pathname.split('/')[1]}` === process.env.PUBLIC_URL ? location.pathname.split('/')[2] : location.pathname.split('/')[1];

        const currentRoute = this.getCurrentRoute();
        const routePagination = currentRoute.pagination;

        const currentRouteIndex = routes.findIndex(({ path }) => location.pathname.endsWith(path));
        const previousRouteIndex = currentRouteIndex - 1 >= 0 ? currentRouteIndex - 1 : null;
        const nextRouteIndex = currentRouteIndex + 1 <= routes.length - 1 ? currentRouteIndex + 1 : null;

        let previous = previousRouteIndex !== null && routePagination !== false ? {
            label: 'Back',
            path: `${process.env.PUBLIC_URL}/${basePath}${paginationPreviousRoute !== false ? paginationPreviousRoute : routes[previousRouteIndex].path}`
        } : false;

        let next = nextRouteIndex !== null && routePagination !== false ? {
            label: 'Next',
            path: `${process.env.PUBLIC_URL}/${basePath}${routes[nextRouteIndex].path}`,
            type: 'link',
            tracking: () => {}
        } : false;

        let skip = nextRouteIndex !== null && routePagination !== false ? {
            ...next,
            label: 'Skip'
        } : false;

        if(typeof routePagination === 'object'){
            previous = previous !== false && typeof routePagination.previous === 'object' ? {
                label: routePagination.previous.label ? routePagination.previous.label : previous.label,
                path: routePagination.previous.path ? routePagination.previous.path : previous.path
            } : routePagination.previous === false ? routePagination.previous : previous;

            next = next !== false && typeof routePagination.next === 'object' ? {
                label: routePagination.next.label ? routePagination.next.label : next.label,
                path: routePagination.next.path ? routePagination.next.path : next.path,
                type: routePagination.next.type ? routePagination.next.type : next.type,
                tracking: routePagination.next.tracking ? routePagination.next.tracking : next.tracking
            } : routePagination.next === false ? routePagination.next : next;

            if(paginationSkipState) {
                skip = {
                    ...next,
                    label: 'Skip'
                };

                skip = skip !== false && typeof routePagination.skip === 'object' ? {
                    label: routePagination.skip.label ? routePagination.skip.label : skip.label,
                    path: routePagination.skip.path ? routePagination.skip.path : skip.path,
                    type: routePagination.skip.type ? routePagination.skip.type : skip.type
                } : routePagination.skip === false ? routePagination.skip : skip;
            }
        }

        return {
            active: previous !== false || next !== false,
            previous,
            next,
            skip
        };
    }

    render() {
        const {
            props: {
                location: {
                    pathname
                },
                paginationSkipState,
                updatePaginationSkip,
                updatePaginationPreviousRoute
            }
        } = this;

        if (pathname === '/') return null;

        const currentRoute = this.getCurrentRoute();
        const pagination = this.generatePagination();
        const paginationClasses = `${styles.pagination} ${pagination.active === false ? 'hidden' : ''}`;

        return (
            <div className={paginationClasses}>
                {
                    pagination.previous && !paginationSkipState &&
                    <Link
                        to={pagination.previous.path}
                        className={styles.back}
                        onClick={() => updatePaginationPreviousRoute(false)}
                    >
                        <span className={styles.label} dangerouslySetInnerHTML={{__html: pagination.previous.label}}/>
                    </Link>
                }
                {
                    pagination.next && pagination.next.type === 'link' && !paginationSkipState &&
                    <Link
                        to={pagination.next.path}
                        onClick={pagination.next.tracking}
                        className={styles.next}
                    >
                        <span className={styles.label} dangerouslySetInnerHTML={{__html: pagination.next.label}}/>
                    </Link>
                }
                {
                    pagination.next && pagination.next.type === 'submit' && !paginationSkipState &&
                    <SubmitButton form={currentRoute.path} className={styles.next} onClick={() => updatePaginationPreviousRoute(false)}>
                        <span className={styles.label} dangerouslySetInnerHTML={{__html: pagination.next.label}}/>
                    </SubmitButton>
                }
                {
                    pagination.skip && pagination.skip.type === 'link' && paginationSkipState &&
                    <Link
                        to={pagination.skip.path}
                        onClick={pagination.skip.tracking}
                        className={styles.skip}
                    >
                        <span className={styles.label} dangerouslySetInnerHTML={{__html: pagination.skip.label}}/>
                    </Link>
                }
                {
                    pagination.skip && pagination.skip.type === 'submit' && paginationSkipState &&
                    <SubmitButton
                        form={currentRoute.path}
                        onClick={() => updatePaginationSkip(false)}
                        className={styles.skip}
                    >
                        <span className={styles.label} dangerouslySetInnerHTML={{__html: pagination.skip.label}}/>
                    </SubmitButton>
                }
            </div>
        );
    }
}

const mapStateToProps = ({ calculator }, ownProps) => ({
    paginationState: calculator.pagination,
    paginationSkipState: calculator.paginationHasSkip,
    paginationPreviousRoute: calculator.paginationPreviousRoute,
    ...ownProps
});

const mapDispatchToProps = (dispatch) => ({
    updatePagination: dispatch(updatePagination),
    updatePaginationSkip: dispatch(updatePaginationSkip),
    updatePaginationPreviousRoute: dispatch(updatePaginationPreviousRoute)
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Pagination));
